export default __webpack_public_path__ + "static/media/MarvelousMotion_01.27f3cc27.png";